import React from "react";
import {Outlet} from "react-router-dom";
import "./ImageMatcher.scss";


const ImageMatcherPage: React.FC = () => {
    return <Outlet/>;
};

export default ImageMatcherPage;
